import { createClient } from '@supabase/supabase-js';

// Get environment variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Validate configuration
if (!supabaseUrl) {
  throw new Error('VITE_SUPABASE_URL environment variable is required. Please check your .env file.');
}

if (!supabaseAnonKey) {
  throw new Error('VITE_SUPABASE_ANON_KEY environment variable is required. Please check your .env file.');
}

// Create Supabase client
const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Log configuration for debugging (only in development)
if (import.meta.env.DEV) {
  console.log('Supabase configured with:', {
    url: supabaseUrl,
    hasAnonKey: !!supabaseAnonKey,
    env: import.meta.env.MODE
  });
}

export { supabase };
